export function extractAuthenticationHeader(response) {
    const accessToken = response.headers.get('access-token');
    const expiry = response.headers.get('expiry');
    const uid = response.headers.get('uid');
    const client = response.headers.get('client');
    return {
        access_token: accessToken,
        expiry: expiry,
        uid: uid,
        client: client,
    };
}

export function transformResponse(response) {
    return new Promise(function(resolve, reject) {
        response.json().then(function(json) {
            response.json = json;
            resolve(response);
        });
    });
}

export function parseJSON(response) {
    return response.json();
}

export function checkHttpStatus(response) {
    if (response.status >= 200 && response.status < 300) {
        return response;
    } else {
        const error = new Error(response.statusText);
        error.response = response;
        throw error;
    }
}
